(()=> {
  const sel = 'cart-drawer, .cart-drawer, .drawer';
  function ensureBar() {
    const drawer = document.querySelector(sel);
    if (!drawer) return;
    const inner = drawer.querySelector('.drawer__inner, .cart-drawer__inner, .drawer__contents') || drawer;
    if (inner.querySelector('#t2-cartbar')) return;
    const bar = document.createElement('div');
    bar.id = 't2-cartbar';
    bar.innerHTML = `<span class="t2-title">Warenkorb</span><span class="t2-dot">•</span><span class="t2-sub">–</span>`;
    inner.prepend(bar);
    updateBar();
  }
  function readSubtotal() {
    const drawer = document.querySelector(sel);
    if (!drawer) return null;
    return (
      drawer.querySelector('[data-cart-subtotal]') ||
      drawer.querySelector('.totals__subtotal-value') ||
      drawer.querySelector('.cart-drawer__footer .price, .cart__footer .price')
    );
  }
  function updateBar(){
    const bar = document.querySelector('#t2-cartbar');
    const sub = readSubtotal();
    if (bar && sub) bar.querySelector('.t2-sub').textContent = sub.textContent.trim();
  }
  const mo = new MutationObserver(()=>{ ensureBar(); updateBar(); });
  window.addEventListener('DOMContentLoaded', ()=>{ ensureBar(); updateBar(); mo.observe(document.body,{subtree:true,childList:true,attributes:true}); });
})();
